import { showTotals } from './_updateShipping';

export const updateGiftWrapValue = (form, giftWrapped, itemNumber, orderItemId) => {
	$.ajax({
		url: '/webapp/wcs/stores/servlet/ShipModeUpdate?quantity_*=&isPickupItem_*=&orderItemId_*=&shipmodeId_*=&addressId_*=',
		cache: false,
		type: 'POST',
		data: 'orderItemId=' + orderItemId + '&orderId=' + form.orderId.value + '&giftWrap=' + giftWrapped + '&updatePrices=1',
		success: function (json) {
			var successResp = json.JSON;
			if (successResp !== null) {
				showTotals(successResp);
				//$(".totalGiftWrapCharge").html(successResp.newGiftWrapTotal == null ? "" : successResp.newGiftWrapTotal);
				//$('.totalGiftWrap').css("display", "block");
				//if (successResp.newGiftWrapTotal == "$0.00" || successResp.newGiftWrapTotal === "") $('.totalGiftWrap').css("display", "none");
			}
			return false;
		},
	});
};
